module.exports = __webpack_public_path__ + "static/medika1-image-2-ed4a9eee247a9a4a68178af0f7441ae8.png";